import React from 'react';
import { useMutation } from 'react-fetching-library';
import { Card, CardContent, CardHeader, Box, TextField, Button, Alert, Stack } from '@mui/material';
import { Logo } from './landing/Logo';

export default function PasswordBox({ id, setIsCodeValid, setIsSent, action, buttonText, handlePayload, numbersOnly }) {
  const [code, setCode] = React.useState('');
  const { error, mutate } = useMutation(action);
  const [customErrorMessage, setCustomErrorMessage] = React.useState('');

  const handleChange = e => {
    if (numbersOnly) {
      const reg = /^\d+$/;
      if (reg.test(e.target.value) || e.target.value === '') {
        setCode(e.target.value);
      }
    } else {
      setCode(e.target.value);
    }
  };

  const handleSubmit = async () => {
    const { payload, error, loading } = await mutate(id, { code });
    if (!error && !loading) {
      if (payload.success === true) {
        setIsCodeValid(true);
        if (payload.is_send) {
          setIsSent(payload.is_send);
        }
        if (handlePayload) {
          handlePayload(payload);
        }
      } else {
        setCustomErrorMessage(payload.custom_error_message);
      }
    }
  };

  return (
    <Box sx={{ height: '100vh', width: '100vw', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      <Stack alignItems="center" spacing= {2}>
        <Logo/>
        <Card sx={{ width: '400px', margin: 'auto' }}>
          <CardHeader title="Podaj kod" />
          <CardContent>
            <TextField value={code} onChange={handleChange} fullWidth inputProps={{ style: { textAlign: 'center', fontSize: '26px' }, maxLength: 6 }}></TextField>
            {error ? <Alert severity="error" sx={{ mt: 2 }}>Niepoprawny kod</Alert> : null}
            {customErrorMessage && <Alert severity="error" sx={{ mt: 2 }}>{customErrorMessage}</Alert>}
            <Button variant="contained" fullWidth disabled={code.length < 6} sx={{ mt: 2 }} onClick={handleSubmit}>{buttonText}</Button>
          </CardContent>
        </Card>
      </Stack>
    </Box>
  );
};

